import {
  ContextoCalculoTributo,
  ContextoFormCatalogoProducto,
  EstrategiaCalculoTributo,
  EstrategiaFormCatalogoProducto,
} from "../../interfaces/utils/estrategias-documentos.interface";

export const mapearFormProductoConTipoItemV1: EstrategiaFormCatalogoProducto = (
  { form, productoCatalogo, tributos }: ContextoFormCatalogoProducto
) => ({
  ...form,
  clave: productoCatalogo.clave,
  tipoDescuento: productoCatalogo.descuentoporcentaje ? "porcentaje" : "monto",
  descuento: productoCatalogo.descuento ?? productoCatalogo.descuentodefault,
  descripcion: productoCatalogo.descripcion,
  tipo: productoCatalogo.tipoitem === "0" ? "s" : "p",
  precio: productoCatalogo.preciounitario ?? productoCatalogo.preciounitariodefault,
  unidadMedida: productoCatalogo.unidad,
  tributos: tributos,
});

export const mapearFormProductoConIvaYExentoV1: EstrategiaFormCatalogoProducto = (
  { form, productoCatalogo, tributos }: ContextoFormCatalogoProducto
) => ({
  ...form,
  clave: productoCatalogo.clave,
  conIva: productoCatalogo.ivaincluido,
  descripcion: productoCatalogo.descripcion,
  descuento: productoCatalogo.descuento ?? productoCatalogo.descuentodefault,
  exento: productoCatalogo.exento,
  servicio: productoCatalogo.tipoitem === "0",
  tipoDescuento: productoCatalogo.descuentoporcentaje ? "Porcentaje" : "Monto",
  precio: productoCatalogo.preciounitario ?? productoCatalogo.preciounitariodefault,
  unidadMedida: productoCatalogo.unidad,
  tributos: tributos,
});

export const mapearFormProductoSinCambios: EstrategiaFormCatalogoProducto = (
  { form }: ContextoFormCatalogoProducto
) => ({ ...form });

export const calcularTributoPorCantidadAplicaV1: EstrategiaCalculoTributo = (
  { form, subtotal, tributo, valorImpuesto }: ContextoCalculoTributo
): number => {
  let totalTributo = 0;

  if (parseFloat(form.cantidad || 0) >= tributo.cantidadaplica) {
    if (tributo.esporcentaje) totalTributo += subtotal * (valorImpuesto / 100);
    else {
      const aplica = form.cantidad / tributo.cantidadaplica;
      for (let i = 0; i < aplica; i++) {
        totalTributo += valorImpuesto;
      }
    }
  }

  return totalTributo;
};

export const calcularTributoNoAplica: EstrategiaCalculoTributo = (): number => 0;
